import React from "react";

export default function GlobalLoading() {
  return (
    <div className="harwin-global-loading" role="status" aria-live="polite">
      <div className="harwin-loader-ring" aria-hidden="true" />
      <div className="harwin-loader-title">
        Loading Harwin ERP Application...
      </div>
      <div className="harwin-loader-subtitle">Please Wait</div>
      <style>{`
        .harwin-global-loading{position:fixed;inset:0;z-index:99999;display:flex;flex-direction:column;align-items:center;justify-content:center;background:#f8fafc;font-family:inherit;text-align:center;padding:24px}
        .harwin-loader-ring{width:58px;height:58px;border:5px solid #dbeafe;border-top-color:#0d9488;border-radius:50%;animation:harwinSpin .8s linear infinite;margin-bottom:22px}
        .harwin-loader-title{font-size:20px;font-weight:700;color:#172033;letter-spacing:.1px}
        .harwin-loader-subtitle{margin-top:7px;font-size:14px;font-weight:600;color:#64748b}
        @keyframes harwinSpin{to{transform:rotate(360deg)}}
      `}</style>
    </div>
  );
}
